import React, { useState } from 'react';
import { cn } from '@client/lib/utils';

interface UsernameFormProps {
  onSubmit: (username: string) => Promise<void>;
  loading?: boolean;
  error?: string | null;
}

export function UsernameForm({ onSubmit, loading, error }: UsernameFormProps) {
  const [username, setUsername] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (username.trim()) {
      await onSubmit(username.trim());
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="mb-7">
          <div className="relative mx-auto mb-5 w-full max-w-[300px]">
            <div className="overflow-hidden rounded-[24px] bg-secondary shadow-sm rotate-[-1.5deg]">
              <img
                src="/sabrina-stefan-hero.avif"
                alt="Sabrina und Stefan"
                className="aspect-[4/5] w-full object-cover"
                fetchPriority="high"
                decoding="async"
              />
            </div>
            <div className="absolute -left-3 top-5 rotate-[-8deg] rounded-full bg-primary px-3 py-1.5 text-[13px] leading-[18px] font-bold text-primary-foreground shadow-sm">
              S&S
            </div>
            <div className="absolute -right-3 bottom-7 rotate-[6deg] rounded-full bg-background px-3 py-1.5 text-[13px] leading-[18px] font-semibold text-primary shadow-sm border border-[var(--color-ios-separator)]">
              Foto-Missionen
            </div>
          </div>

          <div className="text-center">
            <p className="text-[13px] leading-[18px] font-semibold uppercase tracking-[0.08em] text-primary">
              Wedding Photobooth
            </p>
            <h1 className="text-[34px] leading-[41px] font-bold mt-1">Sabrina & Stefan</h1>
            <p className="text-[17px] leading-[24px] text-muted-foreground mt-3">
              Erfülle Foto-Missionen und hilf uns, die Galerie mit Erinnerungen zu füllen.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Dein Name"
            className={cn(
              'w-full px-4 py-3 bg-secondary rounded-xl',
              'text-[17px] leading-[22px]',
              'placeholder:text-muted-foreground',
              'focus:outline-none focus:ring-2 focus:ring-primary'
            )}
            autoFocus
            disabled={loading}
            maxLength={30}
          />

          {error && (
            <p className="text-destructive text-[13px] leading-[18px] text-center">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading || !username.trim()}
            className={cn(
              'w-full py-3.5 bg-primary text-primary-foreground rounded-[14px]',
              'text-[17px] leading-[22px] font-semibold',
              'disabled:opacity-50 ios-pressable'
            )}
          >
            {loading ? 'Moment...' : 'Mitmachen'}
          </button>
        </form>
      </div>
    </div>
  );
}
